import React, { Component } from "react";
import PropTypes from "prop-types";
import Padding from "../../components/common/Padding";
import colors from "../../styles/colors";

const style = {
  pageLetter: {
    width: "215.9mm",
    height: "297.4mm",
    padding: "5mm",
    display: "flex",
    flexFlow: "column",
    alignItems: "left",
    alignSelf: "center",
  },
  mainHeader: {
    fontSize: 32,
    fontWeight: "bold",
    color: "#696969",
    marginTop: 10,
    marginBottom: 0,
  },
  subHeader: {
    fontSize: 26,
    textAlign: "center",
    color: colors.primary,
  },
  body: {
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: "16px",
    color: "#696969",
    textAlign: "left",
    margin: 20,
  },
  highlightText: {
    fontSize: 20,
    fontWeight: "bold",
    color: colors.accent,
  },
  highlight: {
    display: "inline-block",
    fontSize: 30,
    fontWeight: "bold",
    color: colors.accent,
  },
  row: {
    display: "flex",
    flexFlow: "row",
    justifyContent: "center",
    margin: 20,
  },
  imageLogo: {
    width: 100,
    margin: "auto",
  },
  imageInstructions: {
    height: 400,
  },
  stores: {
    display: "flex",
    flexDirection: "column",
  },
};

class UserInstructionsText extends Component {
  render() {
    return (
      <div id={this.props.id} style={style.pageLetter}>
        <h4 style={style.mainHeader}>Exciting news!</h4>
        <div style={style.body}>
          {this.props.appInfo.appName} is making your life easier! We are using
          an app "AC Health" to prescribe your home exercises. No more handouts,
          paper or emails! All you have to do is download the App and we will do
          the rest. When it's time to do your exercises, you just click the AC
          Health App and view your private personalized exercises.
        </div>
        <Padding height={30} />
        <div style={style.body}>
          {'1. Download the App on Android or iOS by Searching for "AC Health"'}
        </div>
        <Padding height={20} />
        <img
          alt="Help Doc"
          src={"https://i.ibb.co/ch9X50Z/ac-logo.png"}
          style={style.imageLogo}
        />
        <Padding height={20} />
        <div style={style.body}>
          {"2. Register with an email and create a password."}
        </div>
        <Padding height={20} />
        <div style={style.body}>{"3. Accept the Privacy and Terms."}</div>
        <Padding height={20} />
        <div style={style.body}>
          {'4. Click "Find Your Provider", then type'}{" "}
          <span style={style.highlightText}>{this.props.appId}</span>{" "}
          {'in the box and click Enter. Click "Start" and you\'re all ready!'}
        </div>
        <Padding height={20} />
        {this.props.appInfo.isLocked && (
          <div style={style.body}>
            {
              "4. This Channel is locked, and you will be asked to input a code to unlock the content. Type"
            }{" "}
            <span style={style.highlightText}>
              {this.props.appInfo.lockCode}
            </span>{" "}
            {"in the box and click Enter."}
          </div>
        )}
        <Padding height={40} />
        <div style={style.row}>
          <img
            alt="Help Doc"
            src={
              "https://i.ibb.co/C55SCcN/Whats-App-Image-2021-09-08-at-14-01-06-iphone12black-portrait.png"
            }
            style={style.imageInstructions}
          />
          <Padding width={40} />
          <div style={{ position: "relative" }}>
            <div
              style={{
                position: "absolute",
                top: 252,
                left: 36,
                color: "dimgrey",
                backgroundColor:'white',
                width:'50px'
              }}
            >
              {this.props.appId}
            </div>
            <img
              alt="Help Doc"
              src={
                "https://i.ibb.co/tX5HkDc/Whats-App-Image-2021-09-08-at-14-00-24-iphone12black-portrait.png"
              }
              style={style.imageInstructions}
            />
          </div>
          <Padding width={40} />
          <img
            alt="Help Doc"
            src={
              "https://i.ibb.co/tLTsQRZ/Whats-App-Image-2021-09-08-at-14-00-25-iphone12black-portrait.png"
            }
            style={style.imageInstructions}
          />
        </div>
        <Padding height={20} />
        <div style={style.body}>
          {
            "That's it! Now you're ready for your next visit. We look forward to seeing you!"
          }
        </div>
        <Padding height={20} />

        <div style={style.row}>
          <a
            href="https://apps.apple.com/us/app/ac-health/id1210042047"
            style={style.stores}
          >
            <img src={"https://i.ibb.co/0XbPyFB/ios.png"} width="150px" />
            <img
              alt="Help Doc"
              width="150px"
              height="50px"
              src={
                "https://system-data.s3-us-west-2.amazonaws.com/resources/images/app-store-button.png"
              }
            />
          </a>
          <Padding width={40} />
          <a
            href="https://play.google.com/store/apps/details?id=com.advicecoachandroid&hl=en_US"
            style={style.stores}
          >
            <img src={"https://i.ibb.co/Hp8qpPf/android.png"} width="150px" />
            <img
              alt="Help Doc"
              width="150px"
              height="50px"
              src={
                "https://system-data.s3-us-west-2.amazonaws.com/resources/images/google-play-button.png"
              }
            />
          </a>
        </div>
        <div style={style.row}>
          <h3>
            {this.props.appInfo.appName} -- {this.props.appId}{" "}
          </h3>
        </div>
      </div>
    );
  }
}

UserInstructionsText.propTypes = {
  appId: PropTypes.number,
  appInfo: PropTypes.object,
};

export default UserInstructionsText;



// WEBPACK FOOTER //
// ./src/layout/playbook/UserInstructionsText.js